import * as tslib_1 from "tslib";
import { ContentContainer } from './content_container';
var Panel = /** @class */ (function (_super) {
    tslib_1.__extends(Panel, _super);
    function Panel(param) {
        return _super.call(this, param) || this;
    }
    Panel.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Panel" });
    };
    Panel.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Panel;
}(ContentContainer));
export { Panel };
//# sourceMappingURL=panel.js.map